import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { DraggableGrid } from '../DraggableGrid';
import styles from './Carousel.module.scss';
import { renderCarouselItem } from './Carousel.types';
const DraggableItemRenderer = (param)=>{
    let { content, itemTestId, isDragActive, dragHandle } = param;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": itemTestId,
        children: renderCarouselItem(content, {
            isDragActive: !!isDragActive,
            dragHandle
        })
    });
};
export const CarouselDraggableTrack = (param)=>{
    let { items, equalItemWidth, gap, onReorder, itemTestId, reorderBiName, dragMode, handleVisibility, dragActivation, handlePosition } = param;
    const draggableItems = items.map((item)=>({
            id: item.id,
            content: item.content,
            itemTestId: itemTestId(item.id)
        }));
    const props = _object_spread({
        className: styles.draggableTrackOverride,
        itemClassName: cn(styles.draggableItem, {
            [styles.draggableItemEqual]: equalItemWidth
        }),
        items: draggableItems,
        itemComponent: DraggableItemRenderer,
        layout: {
            rows: 1
        },
        gap,
        dragMode,
        itemHandleVisibility: handleVisibility,
        itemDragActivation: dragActivation,
        itemHandlePosition: handlePosition,
        onReorder: (reordered)=>onReorder(reordered.map((item)=>item.id))
    }, reorderBiName != null ? {
        bi: {
            name: reorderBiName
        }
    } : {
        noBi: true
    });
    return /*#__PURE__*/ _jsx(DraggableGrid, _object_spread({}, props));
};
